import React, { useId } from "react";
import { cn } from "@/lib/utils";

interface GradientHeartProps {
  className?: string;
  outlined?: boolean; // when true, show only outline (no fill)
}

const GradientHeart: React.FC<GradientHeartProps> = ({ className, outlined = false }) => {
  const id = useId().replace(/:/g, ""); // ensure valid id

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn(className)}
      fill={outlined ? "none" : `url(#gradient-${id})`}
      stroke={outlined ? "currentColor" : "none"}
      strokeWidth={outlined ? 2 : 0}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={`gradient-${id}`} gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#70BAFF" />
          <stop offset="100%" stopColor="#258BFF" />
        </linearGradient>
      </defs>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
};

export default GradientHeart;
